import { ZoneId } from "@js-joda/core";
import { Tooltip } from "primereact/tooltip";
import React from "react";
import { T } from "services/lang/LanguageService";
import DiffRow from "./DiffRow";

const CurrentValueTooltip = ({
  id,
  value,
  valueKey,
  unit,
  diffDecimalPlaces,
  tz,
}: {
  id: string;
  value: number;
  valueKey: string;
  unit: string;
  diffDecimalPlaces?: number;
  tz: ZoneId;
}) => {
  return (
    <Tooltip target={`#${id}`} mouseTrack mouseTrackLeft={10} position="bottom">
      {value ? (
        <DiffRow
          label={T("word.previous-value")}
          value={value}
          unit={unit}
          timestamp={valueKey}
          diffDecimalPlaces={diffDecimalPlaces}
          tz={tz}
        />
      ) : (
        T("word.no-data")
      )}
    </Tooltip>
  );
};

export default CurrentValueTooltip;
